import PropTypes from 'prop-types';
export var ComponentPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]);
export var ChildrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);
export var RefPropType = PropTypes.oneOfType([
// Function that takes the reference as an argument
PropTypes.func,
// Object with a current property that holds the reference
// eslint-disable-next-line react/forbid-prop-types
PropTypes.shape({
  current: PropTypes.any
})]);